export const cookieNames = {
  lang: "admin_lang",
};
